import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  FeedbackConversation,
  FeedbackMessagePayload,
} from "../../../components/BrieChatMenu/BrieChatFeedback";
import API from "../../api/API";

interface useSendFeedback {
  message: FeedbackMessagePayload;
  onSuccess?: (data: any) => void;
}

const useSendFeedback = () => {
  const queryClient = useQueryClient();

  const sendFeedback = useMutation({
    mutationFn: ({ message }: useSendFeedback) => API.sendFeedback(message),
    onSuccess: (data, { onSuccess }) => {
      queryClient.setQueryData<FeedbackConversation | null>(
        ["feedbackConversation", data.data.data.conversation._id],
        (prev) => {
          const message = data.data.data.conversation.Messages.pop();
          onSuccess && onSuccess(data.data.data.conversation);
          if (!prev) return;

          return { ...prev, Messages: [...(prev.Messages ?? []), message] };
        }
      );
      queryClient.invalidateQueries({
        queryKey: ["feedbackMessages"],
      });
    },
  });

  return {
    sendFeedback: sendFeedback.mutate,
    sendingFeedback: sendFeedback.isPending,
    sendFeedbackError: sendFeedback.error,
  };
};

export default useSendFeedback;
